import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Card } from "./ui/card";
import { Button } from "./ui/button";
import { Sparkles, ArrowRight, CalendarDays, PackageX, Clock, Wallet, AlertTriangle } from "lucide-react";

const ICONS = { reservations: CalendarDays, stock: PackageX, expiry: Clock, cash: Wallet, food_cost: AlertTriangle };

export function MorningBriefCard() {
  const [brief, setBrief] = useState(null);
  useEffect(() => { api.get("/ai/manager/brief").then(({ data }) => setBrief(data)).catch(() => {}); }, []);
  if (!brief || !brief.insights?.length) return null;
  return (
    <Card className="p-5 rounded-xl mb-8 border border-border/70" data-testid="dashboard-morning-brief">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2 text-primary">
          <Sparkles className="w-5 h-5" />
          <h3 className="font-dash font-semibold text-lg">Dogana AI — Oggi</h3>
        </div>
        <Link to="/dogana-ai">
          <Button variant="outline" size="sm" className="rounded-full" data-testid="brief-open-ai">
            Apri Dogana AI <ArrowRight className="w-4 h-4 ml-1" />
          </Button>
        </Link>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2">
        {brief.insights.slice(0, 5).map((i, k) => {
          const Ic = ICONS[i.type] || AlertTriangle;
          return (
            <div key={k} className="flex items-start gap-2 text-sm rounded-lg bg-secondary/60 p-2.5" data-testid={`dashboard-brief-${i.type}`}>
              <Ic className="w-4 h-4 mt-0.5 text-[#C9A24B] shrink-0" />
              <span>{i.text}</span>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
